import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { useFeatures } from './composables/useFeatures';
import './assets/theme.css';

// Block app mount on feature-flag load so every gated component sees the
// correct flag state on its first render. The endpoint is public and fast;
// if it fails, useFeatures falls back to all-false which is the safest
// posture anyway. Wrapped in an async IIFE because top-level await is not
// available in our Vite browser targets.
void (async () => {
  await useFeatures().load();
  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  app.mount('#app');
})();
